// Creates an 'account-search' url that should redirect to the returnUrl after account select
export const getAccountsUrlWithReturn = (returnUrl = '') => {
  const url = returnUrl || `${window.location.origin}${window.location.pathname}`;
  const encodedUrl = encodeURIComponent(url);
  return `/account-search?returnUrl=${encodedUrl}`;
};
